// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetCpdRegionsRequest, TGetCpdRegionsModel, IMappers, TGetCpdRegionsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2GetCpdRegionsResponse } from '../../entities/v2_get_cpd_regions/V2GetCpdRegionsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetCpdRegionsModel(parameters: IGetCpdRegionsRequest): TGetCpdRegionsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'cpd',
    pathApi: '/v2/get-cpd-regions/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetCpdRegionsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetCpdRegionsRequest;
}

export async function fetchGetCpdRegions<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetCpdRegionsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetCpdRegionsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetCpdRegionsModel(parameters),
    config,
  )) as FetchResponse<TGetCpdRegionsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2GetCpdRegionsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetCpdRegionsResponse>;
}
